import React from 'react';

import 'react-datetime/css/react-datetime.css';
import { Modal, ModalBody } from 'reactstrap';
import cityTimezones from 'city-timezones';
import moment from 'moment-timezone';
import conference from '../../assets/img/event/conference.jpg'
import virtual from '../../assets/img/event/virtual.jpeg'
import hybrid from '../../assets/img/event/hybrid.jpeg'

import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import TimeField from '../../components/inputs/timeField';
import ExpandableListItem from '../../components/list/expandableListItem';
import ToggleField from '../../components/inputs/toggleField';
import Dropzone from 'react-dropzone';
import ColorField from '../../components/inputs/colorField';
import LocationLookup from '../../components/inputs/locationLookup';


const defaultPermissions = {
	details: { label: "Details", slug: 'details', write: true, read: true },
	attendees: { label: "Attendees", slug: 'attendees', write: true, read: true },
	schedule: { label: "Schedule", slug: 'schedule', write: true, read: true },
	groups: { label: "Groups", slug: 'groups', write: true, read: true },
	inventory: { label: "Inventory", slug: 'inventory', write: true, read: true, addon: 'inventory' },
	emails: { label: "Emails", slug: 'emails', write: true, read: true },
	texting: { label: "Texting", slug: 'texting', write: true, read: true, addon: 'texting' },
	forms: { label: "Forms", slug: 'forms', write: true, read: true },
	pages: { label: "Pages", slug: 'pages', write: true, read: true },
	engagement: { label: "Engagement", slug: 'engagement', write: true, read: true, addon: 'engagement' },
	media: { label: "Media", slug: 'media', write: true, read: true },
	insights: { label: "Insights", slug: 'insights', write: true, read: true },
}

let dropzoneBannerRef;
let dropzoneLogoRef;
class AddEventModal extends React.Component {
	constructor(props) {
		super(props);

		const eventBranding = {
			accentColor: props.organization.branding.accentColor,
			fontColor: props.organization.branding.fontColor,
			backgroundColor: props.organization.branding.backgroundColor,
			logo: { name: "Organization Logo", preview: props.organization.branding.logo },
		};

		const salesforceIntegration = props.organization.integrations.find((integration) => integration.identifier == 'salesforce');
		let sfRegStatus = 'Registered';
		let sfCheckinStatus = 'Checked In';
		let sfNotAttendingStatus = 'Did Not Attend';
		if (salesforceIntegration) {

			salesforceIntegration.requiredFields.forEach((field) => {
				if (field.id === 'registeredStatus') sfRegStatus = field.value;
				if (field.id === 'checkedinStatus') sfCheckinStatus = field.value;
				if (field.id === 'didNotAttendStatus') sfNotAttendingStatus = field.value;
			});
		}

		this.state = {
			sectionCount: 3,
			currentSection: 0,
			nextSectionEnabled: false,
			event: {
				experienceType: '',
				name: '',
				startDate: moment().format('MM/DD/YYYY'),
				endTime: '5:00 PM',
				startTime: '8:00 AM',
				endDate: moment().format('MM/DD/YYYY'),
				timezone: '',
			},
			cityLookup: '',
			requiredFields: {
				name: false,
				startDate: false,
				endDate: false,
				timezone: false,
			},
			selectedVenue: null,
			eventBranding: eventBranding,
			submitting: false,
			invalid: false,
			locations: props.locations,
			eventTeam: [],
			searchTeam: "",
			venueMap: null,
			lng: -70.9,
			lat: 42.35,
			zoom: 9,
			files: [],
			salesforceEnabled: salesforceIntegration ? true : false,
			salesforceToggled: false,
			salesforceCampaign: '',
			salesforceRegistrationStatus: sfRegStatus,
			salesforceCheckedinStatus: sfCheckinStatus,
			salesforceNotAttendingStatus: sfNotAttendingStatus,
		};

		this.mapContainer = React.createRef();
	}



	onDrop = (files) => {
		this.setState({
			eventBranding: {
				...this.state.eventBranding,
				header: files[0]
			}
		});
	};


	onDropLogo = (files) => {
		this.setState({
			eventBranding: {
				...this.state.eventBranding,
				logo: files[0]
			}
		});
	};

	handleNewVenueChange = (e) => {
		const newVenue = {
			label: 'New Location: ' + e,
			color: '#00B8D9',
			new: true
		};
		if (e !== '') {
			this.setState({
				locations: [...this.props.locations, newVenue]
			});
		}
	};

	handleChange = (e) => {
		this.setState({
			name: e.target.value
		});
	};

	handleStartDateChange = (e) => {
		this.setState({
			startDate: moment(e.target.value).format('MM/DD/YYYY')
		});
	};

	handleEndDateChange = (e) => {
		this.setState({
			endDate: moment(e.target.value).format('MM/DD/YYYY')
		});
	};

	handleStartTimeChange = (e) => {
		this.setState({
			startTime: moment(
				`${this.state.startDate !== '' ? this.state.startDate : moment().format('MM/DD/YYYY')} ${e.target
					.value}`
			).format('hh:mm a')
		});
	};

	handleEndTimeChange = (e) => {
		this.setState({
			endTime: moment(
				`${this.state.endDate !== '' ? this.state.endDate : moment().format('MM/DD/YYYY')} ${e.target.value}`
			).format('hh:mm a')
		});
	};

	handleTimezoneChange = (timezone) => {
		this.setState({
			timezone: timezone.value
		});
	};

	handleLocationChange = (location) => {
		if (location.new) {
			this.setState({
				venue: { ...location, label: location.label.split('New Location: ')[1] },
				isNewVenue: true
			});
		} else {
			this.setState({
				venue: location,
				isNewVenue: false
			});
		}
	};

	resetAdd = (e, toggle) => {
		this.setState({
			name: '',
			startDateTime: '',
			endDateTime: '',
			venue: '',
			submitting: false,
			invalid: false
		});
		if (!toggle === true) this.props.toggle();
	};

	createEvent = () => {
		const { handleSubmit } = this.props;
		const { event, selectedVenue, eventBranding, eventTeam, salesforceToggled, salesforceCampaign } = this.state;
		const uploads = [];
		if (eventBranding.header) {
			uploads.push({ file: eventBranding.header, identifier: 'headerImage' })
		}
		if (eventBranding.logo && eventBranding.logo.preview && eventBranding.logo.preview.startsWith('blob:')) {
			uploads.push({ file: eventBranding.logo, identifier: 'logo' })
		}
		event.branding = {
			accentColor: eventBranding.accentColor,
			fontColor: eventBranding.fontColor,
			backgroundColor: eventBranding.backgroundColor,
		};

		event.members = eventTeam;

		if (salesforceToggled) {
			event.integrations = {
				salesforce: {
					campaignName: salesforceCampaign,
					registrationStatus: this.state.salesforceRegistrationStatus,
					checkinStatus: this.state.salesforceCheckedinStatus,
					notAttendedStatus: this.state.salesforceNotAttendingStatus,
				}
			}
		}

		this.setState({ submitting: true });
		if (selectedVenue) {
			if (!selectedVenue.platform) {
				handleSubmit(event, selectedVenue, false, uploads);
			} else {
				handleSubmit({ ...event, venue: selectedVenue.value }, null, false, uploads);
			}
		} else {
			handleSubmit(event, null, false, uploads);
		}
	};

	chooseEventType = (type) => {
		this.setState({
			event: {
				...this.state.event,
				experienceType: type
			},
			nextSectionEnabled: true
		});
	};

	nextSection = () => {
		const { currentSection } = this.state;
		/* if (currentSection + 1 === 1) {
			this.initializeGeocoder();
			this.initializeMap();
		} */
		this.setState({
			currentSection: currentSection + 1,
			nextSectionEnabled: false
		});
	}

	prevSection = () => {
		const { currentSection } = this.state;
		this.setState({
			currentSection: currentSection - 1,
			nextSectionEnabled: true
		});
	}

	updateEventField = (field, value) => {
		const { event, requiredFields, salesforceToggled } = this.state;
		event[field] = value;
		let requiredFieldsAcquired = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!event[key] || event[key] === '') {
				requiredFieldsAcquired = false;
			}
		});
		if (salesforceToggled) {
			if (!this.state.salesforceCampaign || this.state.salesforceCampaign === '') {
				requiredFieldsAcquired = false;
			}
		}

		this.setState({ event, nextSectionEnabled: requiredFieldsAcquired, requiredFields });
	}

	updateRole = (role, index) => {
		let eventTeam = this.state.eventTeam;
		eventTeam[index].role = role.value;
		this.setState({ eventTeam: eventTeam })
	}

	renderSection = (section) => {
		const { currentSection, event, eventBranding, venue, locations, isNewVenue, cityLookup, requiredFields, nextSectionEnabled, salesforceEnabled } = this.state;
		const { name, startDate, endDate, startTime, endTime, timezone, experienceType } = event;

		switch (section) {
			case 0:
				// event type picker
				return <div className={`sectionBody w-100 posAbs anim left ${section == currentSection ? '' : 'closed'}`}>
					<div className='mb-20  mt-10'>
						<h2 className='mb-10'>What type of event do you want to plan?</h2>
						<p>
							Select the type of event based on the features you need. You can always change this later.<br />
							All experiences include attendee schedule management and registration.
						</p>
					</div>
					<div className='flex w-100 flex-wrap' style={{ marginLeft: -10 }}>
						<div className={`contentCard`}>
							<div className={`cardDetailsContainer containerTitle`}>
								<div className='w-100 mr-10'>
									<h3>In-Person Experience</h3>
									<p className='small'>Customer Events, Site Visits, Corporate Retreats</p>
								</div>
								<button className={`neu ${experienceType == 'in-person' ? 'disabled activated' : 'prim'}`} onClick={() => this.chooseEventType('in-person')}>{experienceType == 'in-person' ? 'Selected' : 'Select'}</button>
							</div>

							<div className='imageBannerBackground flex-ac j'  >
								<img src={conference} style={{ maxWidth: '100%' }} />
							</div>

							<div className={`cardDetailsContainer containerFooter`}>
								<div className='h-100'>
									<p className='mb-20'>Event will occur at a physical venue and attendees be attending in person.</p>
									<h5 className='mb-10'>Features</h5>
									<ul>
										<li>Attendee rooming and travel management</li>
										<li>Attendance verification tools</li>
									</ul>
								</div>
							</div>
						</div>

						<div className={`contentCard`} >
							<div className={`cardDetailsContainer containerTitle`}>
								<div className='w-100 mr-10'>
									<h3>Virtual Experience</h3>
									<p className='small'>Product Launches, Lead Engagements</p>
								</div>
								<button className={`neu  ${experienceType == 'virtual' ? 'disabled activated' : 'prim'}`} onClick={() => this.chooseEventType('virtual')}>{experienceType == 'virtual' ? 'Selected' : 'Select'}</button>
							</div>
							<div className='imageBannerBackground flex-ac j'  >
								<img src={virtual} style={{ maxWidth: '100%' }} />
							</div>

							<div className={`cardDetailsContainer containerFooter`}>
								<div className='h-100'>
									<p className='mb-20'>Event will be pre-recorded or streamed and attendees will be attending virtually.</p>
									<h5 className='mb-10'>Features</h5>
									<ul>
										<li>Livestream management studio</li>
										<li>Session surveys and reviews</li>
									</ul>
								</div>
							</div>
						</div>

						<div className={`contentCard`} >
							<div className={`cardDetailsContainer containerTitle`}>
								<div className='w-100 mr-10'>
									<h3>Hybrid Experience</h3>
									<p className='small'>International Conferences, Corporate Meetings</p>
								</div>
								<button className={`neu  ${experienceType == 'hybrid' ? 'disabled activated' : 'prim'}`} onClick={() => this.chooseEventType('hybrid')}>{experienceType == 'hybrid' ? 'Selected' : 'Select'}</button>
							</div>
							<div className='imageBannerBackground flex-ac j'  >
								<img src={hybrid} style={{ maxWidth: '100%' }} />
							</div>

							<div className={`cardDetailsContainer containerFooter`}>
								<div className='h-100'>
									<p className='mb-20'>Attendees will be physically present at the event and will have virtual interactions.</p>
									<h5 className='mb-10'>Features</h5>
									<ul>
										<li>Everything from In-Person and Virtual</li>
										<li>In-App attendee engagement components</li>
									</ul>
								</div>
							</div>
						</div>
					</div>

					{/* <div className='text-c mb-50 mt-50 ph-20'>
						<h3 className='mb-10'>Don't know what to pick?</h3>
						<p>Use the chat widget on the bottom right to talk to our team about your needs.</p>
					</div> */}
				</div>
			case 1:
				const cityTimezoneOptions = cityLookup != ''
					? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => {
						return { label: `${tz.city}, ${tz.province}`, value: tz.timezone };
					})
					: [];



				// event details
				return <div className={`sectionBody w-100 posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
					<div className='mb-20 mt-10'>
						<h2 >Please enter the information below to set up your {experienceType == 'in-person' ? 'In-Person' : experienceType == 'virtual' ? 'Virtual' : 'Hybrid'} experience</h2>
					</div>
					<div className='flex flex-wrap' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 70px)' }}>
						<div className={`sectionBlock mr-15 mb-15`} style={{ maxWidth: 500, paddingLeft: 1 }}>
							<h3 className='blockHeader mb-10'>Basic Information</h3>
							<InputField
								label={'Event Name'}
								required={true}
								errorTrigger={requiredFields.name}
								value={name}
								onChange={(e) => {

									this.updateEventField('name', e.target.value);
								}}
							//subText={`URL: https://${this.props.organization.identifier}.simple.events/${name.replace(/[^A-Za-z0-9]/g, '')}`}
							/>


							<div className="flex-sb w-100">
								<div className="mr-10 w-100">
									<InputField
										label={'Start Date'}
										//value={moment(startDate).format('yyyy-MM-DD')}
										defaultValue={moment(startDate).format('yyyy-MM-DD')}
										required={true}
										errorTrigger={requiredFields.startDate}
										type={'date'}
										inputIcon={<i className="lar la-calendar" />}
										onChange={(e) => {
											this.updateEventField('startDate', moment(e.target.value).format('MM/DD/YYYY'));
										}}
									/>
								</div>

								<div className="ml-10 w-100">
									<InputField
										label={'End Date'}
										//value={moment(endDate).format('yyyy-MM-DD')}
										defaultValue={moment(endDate).format('yyyy-MM-DD')}
										required={true}
										errorTrigger={requiredFields.endDate}
										type={'date'}
										inputIcon={<i className="lar la-calendar" />}
										onChange={(e) => {
											this.updateEventField('endDate', moment(e.target.value).format('MM/DD/YYYY'));
										}}
									/>
								</div>
							</div>
							<div className="flex-sb w-100">
								<div className="mr-10 w-100">
									<TimeField
										label={'Start Time'}
										value={startTime}
										errorTrigger={requiredFields.startTime}
										onChange={(time) => {
											this.updateEventField('startTime', time);
										}}
									/>
								</div>

								<div className="ml-10 w-100">
									<TimeField
										label={'End Time'}
										value={endTime}
										errorTrigger={requiredFields.endTime}
										onChange={(time) => {
											this.updateEventField('endTime', time);
										}}
									/>
								</div>
							</div>

							<div className='pt-20'>
								<h4 className='blockHeader mb-10'>Event Location</h4>
								{(experienceType == 'in-person' || experienceType == 'hybrid') && (
									<LocationLookup selectedPlace={this.state.selectedVenue} locations={this.props.locations} label="Location Finder" placeholder="Search for the venue where the event will take place" noOptionsMessage="No results" onSelect={(location) => {
										if (location.timezone) {
											this.updateEventField('timezone', location.timezone);
										}
										this.setState({ selectedVenue: location })
									}} classes="w-100" />
								)}

								<SelectField
									label={'Timezone'}
									value={{ value: timezone, label: timezone }}
									placeholder="Search for nearest city"
									name="timezones"
									classes="w-100"
									options={cityTimezoneOptions}
									required={true}
									errorTrigger={requiredFields.timeZone}
									onInputChange={(text) => {
										this.setState({ cityLookup: text });
									}}
									noOptionsMessage={({ inputValue }) =>
										!inputValue ? 'Type city name to get options' : 'No cities match your search'}
									onChange={(timezone) => {
										this.updateEventField('timezone', timezone.value);
									}}
								/>
							</div>
							{salesforceEnabled && <div>
								<h3 className='blockHeader'>Salesforce</h3>
								<p className='small gray  mb-10'>Connect to Salesforce to sync attendee data and create new leads.</p>
								<ToggleField icons={false} label="Enable Salesforce Integration" checked={this.state.salesforceToggled} onChange={(checked) => {
									if (this.state.salesforceToggled) {
										let requiredFieldsAcquired = true;
										Object.keys(requiredFields).forEach((key) => {
											if (!event[key] || event[key] === '') {
												requiredFieldsAcquired = false;
											}
										});
										this.setState({ salesforceToggled: false, nextSectionEnabled: requiredFieldsAcquired, salesforceCampaign: '' });
									} else {
										this.setState({ salesforceToggled: true, nextSectionEnabled: false });
									}
								}} />
								{this.state.salesforceToggled && <div className="w-100">
									<InputField
										label={'Campaign Name'}
										value={this.state.salesforceCampaign}
										placeholder={'Name the Salesforce campaign for this event'}
										required={true}
										errorTrigger={requiredFields.salesforceCampaign}
										inputIcon={<i className="lab la-salesforce" />}
										onChange={(e) => {

											let requiredFieldsAcquired = true;
											Object.keys(requiredFields).forEach((key) => {
												if (!event[key] || event[key] === '') {
													requiredFieldsAcquired = false;
												}
											});
											if (!e.target.value || e.target.value === '') {
												requiredFieldsAcquired = false;
											}
											this.setState({ salesforceCampaign: e.target.value, nextSectionEnabled: requiredFieldsAcquired });
										}}
									/>

									<InputField
										label={'Registration Status'}
										value={this.state.salesforceRegistrationStatus}
										placeholder={'Registered'}
										onChange={(e) => {
											this.setState({ salesforceRegistrationStatus: e.target.value });
										}}
									/>

									<InputField
										label={'Checked In Status'}
										value={this.state.salesforceCheckedinStatus}
										placeholder={'Checked In'}
										onChange={(e) => {
											this.setState({ salesforceCheckedinStatus: e.target.value });
										}}
									/>

									<InputField
										label={'Did Not Attend Status'}
										value={this.state.salesforceNotAttendingStatus}
										placeholder={'Did Not Attend'}
										onChange={(e) => {
											this.setState({ salesforceNotAttendingStatus: e.target.value });
										}}
									/>
								</div>}

							</div>}
						</div>
						<div className='sectionBlock' style={{ maxWidth: 500 }}>

							<div >
								<h3 className='blockHeader mb-10'>Event Branding</h3>

								<div className='flex aic'>
									<ColorField useHex={true} classes="mr-10" label={'Primary Action Color'} value={eventBranding.accentColor} onChange={(color) => {
										this.setState({ eventBranding: { ...this.state.eventBranding, accentColor: color } })
									}} />
									<ColorField useHex={true} classes="mr-10" label={'Primary Text Color'} value={eventBranding.fontColor} onChange={(color) => {
										this.setState({ eventBranding: { ...this.state.eventBranding, fontColor: color } })
									}} />
									<ColorField useHex={true} label={'Main Background Color'} value={eventBranding.backgroundColor} onChange={(color) => {
										this.setState({ eventBranding: { ...this.state.eventBranding, backgroundColor: color } })
									}} />

								</div>
								<div className="flex aic">
									<div className="formFieldLabel">
										Event Logo Image
									</div>
									{event.logoImage && (<button className='ml-a' onClick={() => {
										this.setState({ event: { ...this.state.event, logoImage: null } })
									}}>Remove</button>)}
								</div>
								<Dropzone
									accept="image/*"
									className="clickable dropzone-details mb-20"
									inputProps={{ style: { margin: 'auto' } }}
									ref={(node) => {
										dropzoneLogoRef = node;
									}}
									onDrop={this.onDropLogo.bind(this)}
								>
									{eventBranding.logo && <img className="dropHeaderImage" src={eventBranding.logo.preview} />}
									<div className="dropzoneDescriptionContainer vert">
										{eventBranding.logo && (<h3>{eventBranding.logo.name}</h3>)}
										<h4>
											<span className='seBlue'>Browse</span>, or drop alternate event logo here.
										</h4>
									</div>
								</Dropzone>

								<div className="flex aic">
									<div className="formFieldLabel">
										Default Event Banner
									</div>
									{event.headerImage && (<button className='ml-a' onClick={() => {
										this.setState({ event: { ...this.state.event, headerImage: null } })
									}}>Remove</button>)}
								</div>
								<Dropzone
									accept="image/*"
									className="clickable dropzone-details banner mb-20"
									inputProps={{ style: { margin: 'auto' } }}
									ref={(node) => {
										dropzoneBannerRef = node;
									}}
									onDrop={this.onDrop.bind(this)}
								>
									{eventBranding.header && <img className="dropHeaderImage" src={eventBranding.header.preview} />}
									<div className="dropzoneDescriptionContainer">
										{eventBranding.header && (<h3>{eventBranding.header.name}</h3>)}
										<h4>
											<span className='seBlue'>Browse</span>, or drop event banner here.
										</h4>
									</div>
								</Dropzone>

							</div>
						</div>
					</div>
				</div>
			case 2:
				const account = this.props.account;
				// event team
				return <div className={`sectionBody w-100 posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
					<div className='mb-20 mt-10'>
						<h2 className='mb-10'>Add team members that will be helping produce this event.</h2>
						<p>
							Set roles and section permissions to tailor each team member's access.
						</p>
					</div>
					<div className='flex w-100'>
						<div className='sectionBlock flex column mr-20'>
							<h4 className='mb-10'>Available Members</h4>
							<InputField classes="mb-10" placeholder={'Search for team members'} value={this.state.searchTeam} onChange={(e) => {
								this.setState({ searchTeam: e.target.value });
							}} />
							<div className='simpleList'>
								{this.props.organization.members.map((member, i) => {
									//if member is already in event team, don't show them
									if (member._id == account._id || member.permission == 'admin') return;
									if (this.state.eventTeam.find(teamMember => teamMember._id == member._id)) return;
									if (this.state.searchTeam && !member.firstName.toLowerCase().includes(this.state.searchTeam.toLowerCase()) && !member.lastName.toLowerCase().includes(this.state.searchTeam.toLowerCase()) && !member.email.toLowerCase().includes(this.state.searchTeam.toLowerCase())) return;
									let emptyProfilePicture = !member || (member && (!member.profilePicture || member.profilePicture === ''));
									return <div className='cardDetailsContainer p-10 mb-20'>
										{emptyProfilePicture ?
											(
												<div className="profileIconContainer d30 mr-10">
													{member.firstName.toUpperCase().charAt(0)}
													{member.lastName.toUpperCase().charAt(0)}
												</div>
											) :
											(
												<img src={member.profilePicture}
													className="acronymCircle profilePicture d30 mr-10" />
											)
										}
										<div>
											<p>{member.firstName} {member.lastName}</p>
											<p className='small'>{member.email}</p>
										</div>
										<button className='prim ml-a' onClick={() => {
											let eventTeam = this.state.eventTeam;
											eventTeam.push({ ...member, permissions: { ...defaultPermissions } });
											this.setState({ eventTeam: eventTeam })
										}}>Add</button>
									</div>
								})}
							</div>
							{/* <button className='neu mt-25' onClick={() => {
								this.setState({ addTeamMember: true })
							}}>Add New Team Member</button> */}

							{/* !nextSectionEnabled && <div className='mt-25 w-100 text-c'><a className='mb-10 click' onClick={() => {
								this.setState({ nextSectionEnabled: true })
							}}>Skip for now</a>
								<p className='small'>You can always add later.</p></div> */}
						</div>
						<div className='sectionBlock flex column'>
							<h4 className='mb-10'>Event Team</h4>
							<div className='simpleList'>
								<ExpandableListItem className='w-100 mb-20'
									expandedContent={(state) => <div className={`expandedContentContainer ${!state.expanded ? 'closed' : ''}`} >

										<h5 className='mb-10'>Sections</h5>
										{Object.keys(defaultPermissions).map((key) => {
											const permission = defaultPermissions[key];
											return <div className='flex aic jcsb' style={{ marginBottom: 5 }}>
												<h4>{permission.label}</h4>
												<div className='flex'>
													<ToggleField disabled icons={false} style={{ margin: 0, marginRight: 10 }} checked={permission.read} label="Read" />
													<ToggleField disabled icons={false} style={{ margin: 0, marginRight: 10 }} checked={permission.write} label="Write" />
												</div>
											</div>
										})}
									</div>}
									render={(state, props) => {

										return <div className='cardDetailsContainer w-100 p-10'>
											<div className="profileIconContainer mr-10 d30">
												{account.firstName.toUpperCase().charAt(0)}
												{account.lastName.toUpperCase().charAt(0)}
											</div>
											<div className='w-100 mr-5'>
												<p>{account.firstName} {account.lastName}</p>
												<p className='small'>{account.email}</p>
											</div>
											<div style={{ textAlign: 'right' }}>
												<h3>Administrator</h3>
												<p className='small'><a className='noBreak'>Full Access</a></p>
											</div>
										</div>
									}} />
								{
									this.props.organization.members.map((member, i) => {
										if (member.permission == 'admin') {
											return (<ExpandableListItem className='w-100 mb-20'
												expandedContent={(state) => <div className={`expandedContentContainer ${!state.expanded ? 'closed' : ''}`} >
													<h5 className='mb-10'>Sections</h5>
													{Object.keys(defaultPermissions).map((key) => {
														const permission = defaultPermissions[key];
														return <div className='flex aic jcsb' style={{ marginBottom: 5 }}>
															<h4>{permission.label}</h4>
															<div className='flex'>
																<ToggleField disabled icons={false} style={{ margin: 0, marginRight: 10 }} checked={permission.read} label="Read" />
																<ToggleField disabled icons={false} style={{ margin: 0, marginRight: 10 }} checked={permission.write} label="Write" />
															</div>
														</div>
													})}
												</div>}
												render={(state, props) => {
													let emptyProfilePicture = !member || (member && (!member.profilePicture || member.profilePicture === ''));
													return <div className='cardDetailsContainer w-100 p-10'>
														{emptyProfilePicture ?
															(
																<div className="profileIconContainer d30 mr-10">
																	{member.firstName.toUpperCase().charAt(0)}
																	{member.lastName.toUpperCase().charAt(0)}
																</div>
															) :
															(
																<img src={member.profilePicture}
																	className="acronymCircle profilePicture d30 mr-10"
																/>
															)
														}
														<div className='w-100 mr-5'>
															<p>{member.firstName} {member.lastName}</p>
															<p className='small'>{member.email}</p>
														</div>
														<div style={{ textAlign: 'right' }}>
															<h3>Administrator</h3>
															<p className='small'><a className=' noBreak'>Full Access</a></p>
														</div>
													</div>
												}} />)
										}
									}
									)}
								{this.state.eventTeam.length > 0 && <div className='flex flex-wrap'>
									{this.state.eventTeam.map((member, i) => {
										const permissions = member.permissions;
										let permissionCount = 0;
										let readCount = 0;
										let writeCount = 0;
										Object.keys(defaultPermissions).forEach((key) => {
											if (permissions[key].read) {
												readCount++;
											}
											if (permissions[key].write) {
												writeCount++;
											}
											permissionCount++;
										});
										let accessString = '';
										let role = "";
										if (Object.keys(defaultPermissions).length === permissionCount && readCount == permissionCount && writeCount == permissionCount) {
											accessString = 'Full Access';
											role = 'Organizer';
										} else if (Object.keys(defaultPermissions).length === permissionCount && writeCount <= permissionCount && writeCount > 0 && readCount >= writeCount) {
											accessString = `Limited Access to ${writeCount} sections`;
											role = 'Staff';
										} else if (Object.keys(defaultPermissions).length === permissionCount && readCount <= permissionCount && readCount > 0) {
											accessString = `Read Only Access to ${readCount} sections`;
											role = 'Guest';
										} else {
											accessString = 'Will not be added';
											role = 'No Access';
										}


										return <ExpandableListItem className='w-100 mb-20'
											expandedContent={(state) => <div className={`expandedContentContainer ${!state.expanded ? 'closed' : ''}`} key={'expandedListItem' + i} >
												<div className='flex aic jcsb' style={{ marginBottom: 10 }} >
													<h5>Sections</h5>
													<div className='flex' style={{ width: 230 }}>
														<ToggleField icons={false} style={{ margin: 0, marginRight: 10 }} checked={readCount === permissionCount} label="All" onChange={(e) => {
															const eventTeam = this.state.eventTeam;
															const checked = e.target.checked
															Object.keys(defaultPermissions).forEach((key) => {
																eventTeam[i].permissions[key].read = checked;
																if (!checked) eventTeam[i].permissions[key].write = false;

															});
															this.setState({ eventTeam });
														}} />
														<ToggleField icons={false} style={{ margin: 0, marginRight: 10 }} checked={writeCount === permissionCount} label="All" onChange={(e) => {
															const eventTeam = this.state.eventTeam;
															Object.keys(defaultPermissions).forEach((key) => {
																eventTeam[i].permissions[key].write = e.target.checked;
																if (e.target.checked) eventTeam[i].permissions[key].read = true;
															});
															this.setState({ eventTeam });
														}} />
													</div>
												</div>
												{Object.keys(defaultPermissions).map((key) => {
													const permission = member.permissions[key];

													return <div className='flex aic jcsb' style={{ marginBottom: 5 }}>
														<h4>{permission.label}</h4>
														<div className='flex' style={{ width: 230 }}>
															<ToggleField icons={false} style={{ margin: 0, marginRight: 10 }} checked={permission.read} label="Read" onChange={(e) => {
																const eventTeam = JSON.parse(JSON.stringify(this.state.eventTeam));
																eventTeam[i].permissions[key].read = e.target.checked;
																if (!eventTeam[i].permissions[key].read) {
																	eventTeam[i].permissions[key].write = false;
																}
																this.setState({ eventTeam });
															}} />
															<ToggleField icons={false} style={{ margin: 0, marginRight: 10 }} checked={permission.write} label="Write" onChange={(e) => {
																const eventTeam = JSON.parse(JSON.stringify(this.state.eventTeam));
																eventTeam[i].permissions[key].write = e.target.checked;
																if (eventTeam[i].permissions[key].write) eventTeam[i].permissions[key].read = true;
																this.setState({ eventTeam });
															}} />
														</div>
													</div>
												})}
												<button className='mt-10 w-100' onClick={() => {
													const eventTeam = this.state.eventTeam;
													eventTeam.splice(i, 1);
													this.setState({ eventTeam });
												}}>Remove</button>
											</div>}
											render={(state, props) => {

												return <div className='cardDetailsContainer w-100 p-10' key={'listItem' + i}>
													<div className="profileIconContainer mr-10 d30">
														{member.firstName.toUpperCase().charAt(0)}
														{member.lastName.toUpperCase().charAt(0)}
													</div>
													<div className='w-100 mr-5'>
														<p>{member.firstName} {member.lastName}</p>
														<p className='small'>{member.email}</p>
													</div>
													<div style={{ textAlign: 'right' }}>
														<h3>{role}</h3>
														<p className='small'><a className='click noBreak' onClick={props.handleExpand}>{accessString} {!state.expanded ? <i className='las la-angle-down ml-5'></i> : <i className='las la-angle-up ml-5'></i>}</a></p>
													</div>
												</div>
											}} />
									})}
								</div>}
							</div>
							{/* <button className='neu mt-25' onClick={() => {
								this.setState({ addTeamMember: true })
							}}>Add New Team Member</button> */}

							{/* !nextSectionEnabled && <div className='mt-25 w-100 text-c'><a className='mb-10 click' onClick={() => {
								this.setState({ nextSectionEnabled: true })
							}}>Skip for now</a>
								<p className='small'>You can always add later.</p></div> */}
						</div>
					</div>
				</div >
			default:
				return;

		}
	}

	render() {
		const { isOpen, toggle } = this.props;
		const { nextSectionEnabled, currentSection, sectionCount, submitting } = this.state;

		return (
			<Modal isOpen={isOpen} toggle={toggle} className="stepSize eventModal">
				<div className="modalHeader">
					<button onClick={toggle} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}><i className='las la-times'></i></button>
					<div className='headerContainer'>

						<h1>Create New Event</h1>
						<h4>Step {currentSection + 1} of {sectionCount}</h4>
						{/* <div className='sectionIndicatorBar'>
							{Array.from(Array(sectionCount).keys()).map((i) => {
								return <div className={`sectionIndicator ${i <= currentSection ? 'selected' : ''}`}></div>
							})}
						</div> */}
					</div>
				</div>
				<ModalBody className="modalBody">
					{this.renderSection(0)}
					{this.renderSection(1)}
					{this.renderSection(2)}

				</ModalBody>
				<div className='flex'>

					{currentSection == 0 ? <button className="neu ml-a mr-15" onClick={toggle}>Cancel</button> : <button className="neu ml-a mr-15" onClick={this.prevSection}>Back</button>}
					{currentSection < sectionCount - 1 ? <button className={`neu  ${nextSectionEnabled ? 'prim' : 'disabled'}`}
						onClick={this.nextSection}>Next</button> : <button className={`neu ${submitting ? 'disabled' : 'prim'}`} onClick={this.createEvent}>{submitting ? "Creating..." : "Create Event"}</button>}
				</div>
			</Modal>
		);
	}
}

export default AddEventModal;
